import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const mediaApi = axios.create({
  baseURL,
  withCredentials: true,
});

export const mediaUrl = (id) => {
  if (!id) return "";
  if (id.startsWith("http") || id.startsWith("/")) return id;
  return `${baseURL}/api/media/${id}`;
};

// Helper: detect whether a URL is hosted on our backend (so we can render it directly).
export const resolveMediaSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/media/")) return `${baseURL}${url}`;
  return url;
};
